export const doctorLoginActions = {
  LOGIN_DOCTOR: {
    REQUEST: 'doctor-login/login-doctor-request',
    SUCCESS: 'doctor-login/login-doctor-success',
    FAILURE: 'doctor-login/login-doctor-failure',
    RESET: 'doctor-login/login-doctor-reset'
  }
};

export const doctorLogoutActions = {
  LOGOUT_DOCTOR: {
    REQUEST: 'doctor-logout/logout-doctor-request',
    SUCCESS: 'doctor-logout/logout-doctor-success',
    FAILURE: 'doctor-logout/logout-doctor-failure',
    RESET: 'doctor-logout/logout-doctor-reset'
  }
};
